
class ImgGridAct {

  static open_grid( wrap ) {
    
    ImgGridAct.imagesGrid( wrap )

    // if ( wrap.closest('.tile').length ) PlGA4.tile_interact('image grid open', wrap.closest('.tile') )
  }

  static mobile_swipe( wrap, forward ) {
    this.check_sources( wrap )

    const curr = wrap.find('.show[img-grid-item]')
    const next = forward ? curr.next('[img-grid-item]') : curr.prev('[img-grid-item]')

    if ( !next.length ) return

    wrap.find('[img-grid-item]').removeClass('show').css('z-index','1')
    next.addClass('show').css('z-index','2')
    this.update_count( wrap )

    // if ( wrap.closest('.tile').length ) PlGA4.tile_interact('image grid swipe', wrap.closest('.tile') )
  }

  static imagesGrid( cnt, index ) {
    const div = cnt <= 4 ? 2 : cnt <= 9 ? 3 : 4;
    const scale = (100 / div) - 1 + '%';

    let trans;

    switch (div) {
      case 2:
        trans = ImgGridAct.grid2(cnt, index);
        break;
      case 3:
        trans = ImgGridAct.grid3(cnt, index);
        break;
      case 4:
        trans = ImgGridAct.grid4(cnt, index);
        break;
      default:
        return ''
    }

    return 'scale(' + scale + ') translate(' + trans + ') translateZ(0)'
  }

  static update_count( wrap ) {
    wrap.siblings('[img-grid-cnt]').find('[vimg-count]').text( wrap.find('.show[img-grid-item]').index() + 1 )
  }

  static grid2(cnt, index) {
    const perc = (100 / 2) + 2

    switch (index) {
      case 0:
        return `-${perc}%,-${cnt <= 2 ? 0 : perc}%`;
      case 1:
        return `${perc}%,-${cnt <= 2 ? 0 : perc}%`;
      case 2:
        return `-${perc}%,${perc}%`;
      case 3:
        return `${perc}%,${perc}%`;
      default:
        return ''
    }
  }

  static grid3(cnt, index) {
    // scale(0.3233) translate(-104.33%,-103%) translateZ(0px)
    const rows = Math.ceil(cnt / 3)
    const perc = Math.abs(51.5 * (1 - rows))

    switch (index) {
      case 0:
        return `-104.33%, -${perc}%`;
      case 1:
        return `0, -${perc}%`;
      case 2:
        return `104.33%, -${perc}%`;
      case 3:
        return `-104.33%, ${rows === 3 ? 0 : perc}%`;
      case 4:
        return `0, ${rows === 3 ? 0 : perc}%`;
      case 5:
        return `104.33%, ${rows === 3 ? 0 : perc}%`;
      case 6:
        return `-104.33%, ${perc}%`;
      case 7:
        return `0, ${perc}%`;
      case 8:
        return `104.33%, ${perc}%`;
      default:
        return ''
    }
  }

  static grid4(cnt, index) {
    // const rows = Math.ceil(cnt / 3)
    // const perc = Math.abs(51.5 * (1 - rows))

    switch (index) {
      case 0:
        return `-156%, -157%`;
      case 1:
        return `-52%, -157%`;
      case 2:
        return `52%, -157%`;
      case 3:
        return `156%, -157%`;
      case 4:
        return `-156%, -54%`;
      case 5:
        return `-52%, -54%`;
      case 6:
        return `52%, -54%`;
      case 7:
        return `156%, -54%`;
      case 8:
        return `-156%, 49%`;
      case 9:
        return `-52%, 49%`;
      case 10:
        return `52%, 49%`;
      case 11:
        return `156%, 49%`;
      case 12:
        return `-156%, 152%`;
      case 13:
        return `-52%, 152%`;
      case 14:
        return `52%, 152%`;
      case 15:
        return `156%, 152%`;
      default:
        return ''
    }
  }
}

export default ImgGridAct
